import React from "react";
import Banner from "./components/banner/Banner";
import Contact from "./components/contact/Contact";
import Features from "./components/features/Features";
import Footer from "./components/footer/Footer";
import FooterBottom from "./components/footer/FooterBottom";
import Navbar from "./components/navbar/Navbar";
import Projects from "./components/projects/Projects";
import About from "./components/about/About";
import Achievements from "./components/achievements/Achievements";
import Resume from "./components/resume/Resume";
import Competitions from "./components/competitions/Competitions";
import Testimonial from "./components/tesimonial/Testimonial";
import styles from "./App.module.css";

function App() {
  return (
    <div className={styles.appContainer}>
      <Navbar />
      <div className={styles.contentWrapper}>
        <Banner />
        <About />
        <Achievements />
        <Features />
        <Projects />
        <Resume />
        <Competitions />
        <Testimonial />
        <Contact />
        <Footer />
        <FooterBottom />
      </div>
    </div>
  );
}

export default App;
